import { Row, RenderConfig, TextInput, Column, EMPTY_ARRAY, SelectInput } from 'commons-ui';
import { USER_ID_TYPE_OPTIONS } from '../utils/constants';

export const FORM_FIELD_KEYS = {
	USER_DETAIL: 'userDetail',
	USER_ID: 'userId',
	REFERRAL_CODE: 'referralCode'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.USER_DETAIL]: 'User Id Type',
	[FORM_FIELD_KEYS.USER_ID]: 'Id',
	[FORM_FIELD_KEYS.REFERRAL_CODE]: 'Referral Code'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.USER_DETAIL]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.USER_DETAIL)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.USER_DETAIL])
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: USER_ID_TYPE_OPTIONS,
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			required: true
		}),
	[FORM_FIELD_KEYS.USER_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.USER_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.USER_ID])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.REFERRAL_CODE]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.REFERRAL_CODE)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.REFERRAL_CODE])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.USER_DETAIL)]), new Column([new Row(FORM_FIELD_KEYS.USER_ID)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.REFERRAL_CODE)])])
];
